// eslint-disable-next-line no-unused-vars
import fetch from 'whatwg-fetch'
import Promise from 'promise-polyfill'
import { FirebaseRemoteConfig } from 'holocron-web-common'

if (!window.Promise) window.Promise = Promise

const {
  NODE_ENV,
  FIREBASE_DB_URL
} = process.env

function noop () { }

var envSettings = process.env

var timingRegexp = /(\d+.?\d*)(s)/

var defaultAvatarStyles = [
  ['width', '70px'],
  ['height', '70px'],
  ['borderRadius', '50%'],
  ['background', 'white'],
  ['padding', '15px'],
  ['boxShadow', '0 1px 6px rgba(0,0,0,.06),0 2px 32px rgba(0,0,0,.16)'],
  ['cursor', 'pointer'],
  ['position', 'fixed'],
  ['boxSizing', 'content-box'],
  ['zIndex', 1000],
  ['bottom', '30px'],
  ['right', '30px'],
  ['boxSizing', 'border-box']
]

var defaultChatStyles = [
  ['width', '400px'],
  ['height', '600px'],
  ['position', 'fixed'],
  ['boxSizing', 'content-box'],
  ['zIndex', 1000],
  ['bottom', '30px'],
  ['right', '120px'],
  ['opacity', '0'],
  ['display', 'none'],
  ['transform', 'translateY(20px)'],
  ['boxShadow', '0 5px 40px rgba(0,0,0,.16)'],
  ['borderRadius', '8px'],
  ['transition', 'all 0.2s ease'],
  ['transitionProperty', 'opacity, transform'],
  ['transitionDuration', '0.2s'],
  ['transitionTimingFunction', 'ease'],
  ['overflow', 'hidden']
]

const HolocronCollapser = function (settings) {
  if (!settings) settings = {}

  this.settings = {
    attachTo: settings.attachTo || document.querySelector('body'),
    avatar: settings.avatar || (envSettings.COLLAPSER_FE_ENDPOINT + '/static/icon_intercom.png'),
    url: settings.url || (envSettings.COLLAPSER_FE_ENDPOINT + '/?flow=test-live-chat'),
    callbacks: settings.callbacks || {},
    shouldRenderAvatar: settings.shouldRenderAvatar || true,
    avatarStyles: defaultAvatarStyles.concat(settings.avatarStyles || []),
    chatStyles: defaultChatStyles.concat(settings.chatStyles || []),
    onlineStatusCheck: true,
    onlineStatusCheckDelay: settings.onlineStatusCheckDelay || 60000,
    onlineStatusCheckFlow: settings.onlineStatusCheckFlow || 'test-live-chat',
    chatTiming: 0,
    hasCloseButton: false || settings.hasCloseButton
  }

  this.loaded = false

  this.attach()

  window.addEventListener('message', receiveMessage.bind(this), false)

  function receiveMessage (event) {
    if (event.data === 'holocron-collapser::request_close') {
      this.collapse()
    }
  }
}

HolocronCollapser.prototype.styleAvatar = function () {
  this.avatarElement.innerHTML = '<img style="width: 32px; margin: 4px;" src="' + this.settings.avatar + '" alt="Begin holocron chat!" />'
  this.avatarElement.className = 'holocron__avatar'

  // use style here

  this.settings.avatarStyles.forEach(function (v) {
    this.avatarElement.style[v[0]] = v[1]
  }.bind(this))

  return
}

HolocronCollapser.prototype.styleChatFrame = function () {
  this.frameElement.innerHTML = '<iframe style="width:100%;height: 100%;border:none;" src="' + this.settings.url + '" />'
  this.frameElement.src = this.settings.url
  this.frameElement.className = 'holocron__chat-window'

  // use style here

  this.settings.chatStyles.forEach(function (v) {
    if (v[0] === 'transitionDuration') {
      var parsedExpression = v[1].match(timingRegexp)
      var units = parsedExpression[1]
      var measure = parsedExpression[2] === 'ms' ? 1 : 1000
      this.settings.chatTiming = units * measure
    }
    this.frameElement.style[v[0]] = v[1]
  }.bind(this))

  return
}

HolocronCollapser.prototype.attach = function () {
  (this.settings.callbacks.beforeAttach || noop)(this)
  this.avatarElement = document.createElement('div')
  this.frameElement = document.createElement('div')
  this.closeElement = document.createElement('div')

  this.styleAvatar()
  this.styleChatFrame()

  this.settings.attachTo.appendChild(this.avatarElement)
  this.frameElement.appendChild(this.closeElement)

  this.avatarElement.addEventListener('click', this.toggle.bind(this), true)
  this.closeElement.addEventListener('click', this.collapse.bind(this), true);

  (this.settings.callbacks.afterAttach || noop)(this)
  if (this.settings.onlineStatusCheck) {
    this.onlineStatusCheck()
    setInterval(this.onlineStatusCheck.bind(this), this.settings.onlineStatusCheckDelay)
  }
  return
}

HolocronCollapser.prototype.collapse = function () {
  (this.settings.callbacks.beforeCollapse || noop)(this)
  this.frameElement.style.opacity = '0'
  window.setTimeout(function () {
    this.frameElement.style.display = 'none'
  }.bind(this), this.settings.chatTiming)
  this.frameElement.style.transform = 'translateY(20px)';
  (this.settings.callbacks.afterCollapse || noop)(this)
  return
}

HolocronCollapser.prototype.expand = function () {
  (this.settings.callbacks.beforeExpand || noop)(this)
  this.frameElement.style.display = 'block'

  if (!this.loaded) {
    this.settings.attachTo.appendChild(this.frameElement)
    this.loaded = true
  }
  window.setTimeout(function () {
    this.frameElement.style.opacity = '1'
    this.frameElement.style.transform = 'translateY(0px)'
  }.bind(this), 0);

  (this.settings.callbacks.afterExpand || noop)(this)
  return
}

HolocronCollapser.prototype.toggle = function () {
  const fn = this.frameElement.style.opacity === '0' ? 'expand' : 'collapse'
  this[fn]()
  return
}

HolocronCollapser.prototype.onlineStatusCheck = function () {
  Promise.all([
    FirebaseRemoteConfig.loadFlowConfig(FIREBASE_DB_URL, NODE_ENV, this.settings.onlineStatusCheckFlow),
    FirebaseRemoteConfig.loadServerTimeOffset(FIREBASE_DB_URL)
  ]).then(([config, offsetTime]) => {
    const serverDate = FirebaseRemoteConfig.computeServerDate(offsetTime)
    const state = FirebaseRemoteConfig.extractOfficeState(config.openHours, serverDate)
    const successCallback = this.settings.callbacks.onlineStatusCheckSuccess || noop
    successCallback({ state })
  }).catch(this.settings.callbacks.onlineStatusCheckFail || noop)
}

module.exports = HolocronCollapser

// To be added to reee JS

// function instantiateChat () {
//   var holocronWidget = new HolocronCollapser({
//     url: 'https://holocron-web-frontend-stg.firebaseapp.com/?flow=reee-ia-support',
//     onlineStatusCheckDelay: 60000,
//     avatarStyles: [
//       ['display', 'none']
//     ],
//     chatStyles: [
//       ['bottom', '0px'],
//       ['right', '10px'],
//       ['width', '310px'],
//       ['height', '380px'],
//       ['position', 'fixed'],
//       ['zIndex', 999]
//     ],
//     callbacks: {
//       afterAttach: function (collapserInstance) {
//         var respDialog = document.querySelector('#stickyREEE');
//         var button = document.querySelector('#livilyChatLink');
//         button.addEventListener('click', function () {
//           respDialog.className += ' closed';
//           collapserInstance.expand();
//         });
//       },
//       onlineStatusCheckSuccess: function (results) {
//         var button = document.querySelector('.btn-chat-online');
//         if (results.state === 'open') {
//           console.log('open');
//           button.style['display'] = 'block';
//         } else {
//           console.log('closed');
//           button.style['display'] = 'none';
//         }
//       },
//       onlineStatusCheckFail: function () {
//           console.log('fail');
//           button.style['display'] = 'none';
//       },
//     }
//   });
// };

// instantiateChat();

// /To be added

/*
# Exemples:
  ## Bound on button without avatar:
  ```
    function instantiateChat () {
      var holocronWidget = new HolocronCollapser({
        avatarStyles: [
          ['display', 'none']
        ],
        callbacks: {
          afterAttach: afterWidgetAttached
        }
      })
    }

    function afterWidgetAttached (collapserInstance) {
      var button = document.querySelector('body')
      button.addEventListener('click', function () {
        collapserInstance.expand()
      })
    }
  ```

  ## Using default button and custom positioning for chat window
  ```
    function instantiateChat () {
      // You can also modify the style using the `holocron__chat-window` and `holocron__avatar` css classes
      var holocronWidget = new HolocronCollapser({
        chatStyles: [
          ['bottom', '0px'],
          ['right', '550px'],
          ['width', '700px'],
          ['height', '900px']
        ]
      })
    }
  ```

  ## Using the onlineStatusCheck feature
  ```
    function instantiateChat () {
      var holocronWidge = new HolocronCollapser({

        callbacks: {
          onlineStatusCheckSuccess: handleOnlineStatusSuccess,
          onlineStatusCheckFail: handleOnlineStatusFail
        }
      })
    }

    function handleOnlineStatusSuccess (response) {
      // `response.state === 'open'` means the button should be shown
    }

    function handleOnlineStatusFail (response) {
      // Server error. If it is outside business hours, the request will still succeed with a different state
    }
  ```

Those are only a few options you can use, see the constructor for more
*/

// function instantiateChat () {
//   var holocronWidget = new HolocronCollapser({
//     url: 'https://holocron-web-frontend-stg.firebaseapp.com/?flow=reee-ia-support',
//     onlineStatusCheckDelay: 60000,
//     avatarStyles: [
//       ['display', 'none']
//     ],
//     chatStyles: [
//       ['bottom', '0px'],
//       ['right', '10px'],
//       ['width', '330px'],
//       ['height', '380px'],
//       ['position', 'fixed'],
//       ['zIndex', 999]
//     ],
//     callbacks: {
//       afterAttach: function (collapserInstance) {
//         var respDialog = document.querySelector('#stickyREEE');
//         var button = document.querySelector('#livilyChatLink');
//         button.addEventListener('click', function () {
//           respDialog.className += ' closed';
//           collapserInstance.expand();
//         });
//       },
//       onlineStatusCheckSuccess: function (results) {
//         var button = document.querySelector('.btn-chat-online');
//         if (results.state === 'open') {
//           button.style['display'] = 'block';
//         } else {
//           button.style['display'] = 'none';
//         }
//       },
//       onlineStatusCheckFail: function () {
//           button.style['display'] = 'none';
//       },
//     }
//   });
// };

// instantiateChat();



// WEBPACK FOOTER //
// ./src/collapser/collapser.js